// Dependencies
import React from 'react';
import radium from 'radium';
import {ThemeContext} from "../../../components/theme/Theme.jsx";

function Image() {
	const context = React.useContext(ThemeContext);
	const style = {
		imageContainerOuter: {
			display: 'flex',
			width: '100%',
			justifyContent: 'space-around',
			height: '12em',
			alignItems: 'center',
			textAlign: '-webkit-center',

		},
		imageContainer: {
			width: '5em',
			height: '5em',
			borderRadius: '50%',
			backgroundColor: context.themeManager
			.value('purchase-success', 'imageBackgroundColor', 'fg-color-icon-highlight'),
			margin: '0 0 1em 0',
		},
		image: {
			backgroundImage: context.themeManager
				.value('purchase-success', 'backgroundImage', 'bg-image-purchase-success'),
			height: '100%',
			backgroundSize: '94% auto',
			backgroundRepeat: 'no-repeat',
			backgroundPosition: '50% 60%',
		},
	};
	return (
		<div style={style.imageContainerOuter} >
			<div style={style.imageContainer} >
				<div style={style.image} />
			</div>
		</div>
	);
}

export default radium(Image);
